import dayjs from './dayjsConfig'
import { Dayjs } from 'dayjs'

export type Half = 1 | 2
export const BUSINESS_TZ = 'America/Argentina/Buenos_Aires'

export function getHalfFromDate(date: Date | string | Dayjs): Half {
  const d = dayjs(date).tz(BUSINESS_TZ)
  const day = d.date()
  return day <= 15 ? 1 : 2
}

export function endOfHalf(date: Date | string | Dayjs): Dayjs {
  const d = dayjs(date).tz(BUSINESS_TZ)
  const half = getHalfFromDate(d)
  if (half === 1) {
    return d.date(15).startOf('day')
  }
  return d.endOf('month').startOf('day')
}

export function endOfPeriod(duration: number, date: Date | string | Dayjs): Dayjs {
  // duration: 0 mensual, 1 quincenal (zonahoraria negocio)
  if (duration === 0) return dayjs(date).tz(BUSINESS_TZ).endOf('month').startOf('day')
  return endOfHalf(date)
}

export function computeBackendDayLimit(
  duration: number,
  selectedDateISO: string,
): number {
  // Returns integer to send to backend: selectedDay - endOfPeriodDay
  const d = dayjs(selectedDateISO).tz(BUSINESS_TZ)
  const end = endOfPeriod(duration, d)
  const delta = d.date() - end.date()
  return delta // should be <= 0
}
